module.exports = __webpack_public_path__ + "img/social-movement.9e22ca8b.svg";